<footer>

  <div class="container footer">

    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <div class="alicent" fxFlex.xl="33.3" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="60" fxFlex.xs="60">
        <div class="alicent">
          <div class="rowdiw wrapper">
            <img class="img-responsive ft" src="assets/medias/img/EDCLIN-LOGO_2019.webp" alt="edclin logo">
          </div>
          <p class="footxt"><small>&copy; 2020. All Rights Reserved.
              <br> Images by ClinSearch, 404 vectors by Flaticon</small></p>
        </div>
      </div>

      <div class="alicent" fxFlex.xl="33.3" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="60" fxFlex.xs="60">
        <h3 class="footxt">Hours &amp; info</h3>
        <p class="footxt"><a href="https://goo.gl/maps/PdkKEBWZtQq" target="_blank" class="footxtb">110 Avenue Pierre
            Brossolette
            <br>92240, Malakoff</a>
        </p>
        <p class="footxt"><a href="tel:+33147351717">+33 (0) 1 47 35 17 17</a></p>
        <p class="footxt"><a href="mailto:info@clinsearch.net">info@clinsearch.net</a></p>
        <p class="footxt">Monday to Friday
          <br class="footxt">8:00 AM to 7:00 PM
        </p>
      </div>

      <div class="alicent"  fxFlex.xl="33.3" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="60" fxFlex.xs="60">
        <h3 class="footxt">About</h3>
        <p class="footxt"><a href="#/contact" routerLink="/contact-form">Contact Us</a></p>
        <!-- <p class="footxt"><a href="privacy.php">Privacy Policy</a></p> -->
        <p class="footxt"><a href="https://fr.linkedin.com/company/clinsearch" target="_blank">LinkedIn</a></p>
      </div>


    </div>
  </div>

</footer>
